import Link from "next/link";

const LEGAL_LINKS = [
  { label: "Privacy Policy",       href: "/privacy" },
  { label: "Terms of Service",     href: "/terms" },
  { label: "Cookie Policy",        href: "/cookies" },
  { label: "Data Usage",           href: "/data-usage" },
  { label: "Subscription Policy",  href: "/subscription-policy" },
  { label: "Refund Policy",        href: "/refund-policy" },
  { label: "Contact Us",           href: "/contact" },
];

const NAV_LINKS = [
  { label: "Features",  href: "/#features" },
  { label: "Pricing",   href: "/pricing" },
  { label: "FAQ",       href: "/faq" },
  { label: "Contact",   href: "/contact" },
  { label: "Sign In",   href: "/login" },
  { label: "Sign Up",   href: "/signup" },
];

export default function PublicFooter() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="border-t py-8 px-6"
      style={{ borderColor: "var(--color-border)", backgroundColor: "var(--color-bg-header)" }}
    >
      <div className="max-w-6xl mx-auto space-y-5">
        {/* Top row: brand | nav | copyright */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Brand */}
          <div className="flex items-center gap-3 shrink-0">
            <div className="w-7 h-7 bg-blue-600 rounded-lg flex items-center justify-center font-bold text-xs text-white select-none">
              M
            </div>
            <span className="font-semibold text-sm" style={{ color: "var(--color-text-primary)" }}>
              Meridian KPI Platform
            </span>
          </div>

          {/* Nav links */}
          <nav
            className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm"
            style={{ color: "var(--color-text-muted)" }}
            aria-label="Footer navigation"
          >
            {NAV_LINKS.map(({ label, href }) => (
              <Link key={href} href={href} className="hover:text-blue-600 transition-colors">
                {label}
              </Link>
            ))}
          </nav>

          {/* Copyright */}
          <p className="text-sm shrink-0" style={{ color: "var(--color-text-muted)" }}>
            &copy; {year} Meridian KPI Platform
          </p>
        </div>

        {/* Legal links row */}
        <div
          className="flex flex-wrap justify-center gap-x-5 gap-y-1.5 text-xs border-t pt-4"
          style={{ borderColor: "var(--color-border)", color: "var(--color-text-muted)" }}
          aria-label="Legal links"
        >
          {LEGAL_LINKS.map(({ label, href }) => (
            <Link key={href} href={href} className="hover:text-blue-600 transition-colors">
              {label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
}
